import React from 'react'

//export default function Loading() {
const Loading = ({ isLoading }) => {
    return (
        <div>Loading....</div>
    )
}
export default Loading
